<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { stringify } from "query-string";
  import {
    apiCall,
    apiUpdate,
    apiCreate,
    apiDelete,
    notify
  } from "../httpCommon";
  import IconButton, { Icon } from "@smui/icon-button";
  import { Textfield, Textshow, RichEdit } from "../components";
  import Card, { Content, Actions, ActionIcons } from "@smui/card";
  import Checkbox from "@smui/checkbox";
  import Dialog, {
    Title,
    Content as DialogContent,
    Actions as DialogActions
  } from "@smui/dialog";
  import Button, { Label } from "@smui/button";
  import Switch from "@smui/switch";
  import FormField from "@smui/form-field";

  const dispatch = createEventDispatcher();
  export let path = "";
  export let data;
  export let notifications;
  export let id;
  export let edit = false;
  let dialog;

  let errors = {};
  $: editOpen = edit || Object.keys(errors).length || (data && !data.id);

  async function load() {
    try {
      const response = await apiCall(`${path}/users/${id}`);
      data = await response.json();
    } catch (error) {
      errors = error.errors;
      notify(error);
    }
  }
  async function save() {
    errors = {};
    try {
      if (id) {
        data = await apiUpdate(`${path}/users`, id, data);
        dispatch("reload");
      } else {
        data = await apiCreate(`${path}/users`, data);
        id = data.id;
      }
      edit = false;
    } catch (error) {
      if (error.errors) {
        errors = error.errors;
      }
      notify(error);
    }
  }

  function remove() {
    if (id) {
      dialog.open();
    } else {
      deleteItem();
    }
  }

  async function close() {
    if (id) {
      await load();
      edit = false;
    } else {
      dispatch("deleted");
    }
  }

  async function deleteItem() {
    dialog.close();
    if (id) {
      try {
        await apiDelete(`${path}/users`, id);
        dispatch("deleted");
      } catch (error) {
        notify(error);
      }
    } else {
      dispatch("deleted");
    }
  }

  onMount(() => {
    if (!data && id) {
      load();
    } else if (data && data.id) {
      id = data.id;
    }
  });
</script>

<style>
  .column {
    display: flex;
    flex-direction: column;
  }
  .fields {
    flex: 1;
  }
</style>

<Card padded variant="outlined">
  <div class="flex">
    {#if editOpen}
      <div class="column fields">
        <div class="flex">
          <span />
          <div>
            <IconButton class="material-icons" on:click={save}>save</IconButton>
            {#if id}
              <IconButton class="material-icons" on:click={load}>
                replay
              </IconButton>
            {/if}
            <IconButton class="material-icons" on:click={close}>
              close
            </IconButton>
          </div>
        </div>
        <div class="flex unspread">
          <Textfield
            bind:value={data.first_name}
            error={errors.first_name}
            label="First Name" />
          <Textfield
            bind:value={data.last_name}
            error={errors.last_name}
            label="Last Name" />
        </div>
        <div class="flex unspread">
          <Textfield
            type="email"
            bind:value={data.email}
            error={errors.email}
            label="Email" />
          <FormField>
            <Switch bind:checked={data.verified} />
            <span slot="label">Email verified</span>
          </FormField>
        </div>
        <div class="flex unspread">
        <Textfield
          bind:value={data.telephone}
          error={errors.telephone}
          label="Telephone" />
          <FormField>
            <Switch bind:checked={data.onsite_contact} />
            <span slot="label">Onsite contact</span>
          </FormField>
        </div>
        <FormField>
          <Switch bind:checked={data.login_allowed} />
          <span slot="label">Login allowed</span>
        </FormField>
        <h4>Recieve Notifications</h4>
        <div>
          {#each notifications as notification}
            <FormField>
              <Checkbox
                bind:group={data.subscriptions}
                value={notification.slug} />
              <span slot="label">{notification.slug}</span>
            </FormField>
          {/each}
        </div>
      </div>
    {:else}
      <div class="column fields">
        <div class="flex">
          <h3>{data.name}</h3>
          <div>
            <IconButton class="material-icons" on:click={remove}>
              delete
            </IconButton>
            <IconButton class="material-icons" on:click={() => (edit = true)}>
              edit
            </IconButton>
          </div>
        </div>
        <div>
          <Icon class="material-icons">contact_mail</Icon>
          <a href="mailto:{data.email}">{data.email}</a>
          {#if data.verified}
            <Icon class="material-icons">done</Icon>
          {/if}
        </div>
        {#if data.telephone}
          <div>
            <Icon class="material-icons">contact_phone</Icon>
            <a href="tel:{data.telephone}">{data.telephone}</a>
          </div>
        {/if}
        <div>
          {#if data.subscriptions.length}
            {data.subscriptions.length} Notification Subscriptions
          {:else}Not subscribed to notifications{/if}
        </div>
      </div>
    {/if}
  </div>
</Card>

<Dialog
  bind:this={dialog}
  aria-labelledby="dialog-title"
  aria-describedby="dialog-content">
  <Title id="dialog-title">Delete Contact '{data.name}'</Title>
  <Content id="dialog-content">
    Are you sure you want to delete the contact {data.first_name}?
  </Content>
  <Actions>
    <Button on:click={() => dialog.close()}>
      <Label>Cancel</Label>
    </Button>
    <Button on:click={deleteItem}>
      <Label>Delete</Label>
    </Button>
  </Actions>
</Dialog>
